import { render, staticRenderFns } from "./join.vue?vue&type=template&id=66b09888&scoped=true"
import script from "./join.vue?vue&type=script&lang=ts"
export * from "./join.vue?vue&type=script&lang=ts"
import style0 from "./join.vue?vue&type=style&index=0&id=66b09888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b09888",
  null
  
)

export default component.exports